import React from "react";

import { EmptyState, Text } from "@performyard/py-components";
import { EmployeeSummary } from "@performyard/service-contracts";

type CoachingRecommendation = NonNullable<EmployeeSummary["coaching_recommendations"]>[number];
type SectionKey = CoachingRecommendation["section"];

const SECTION_LABELS: Record<SectionKey, string> = {
	reviews: "Reviews",
	goals: "Goals",
	meetings: "Meetings",
	feedback: "Feedback",
	competencies: "Competencies",
	general: "General",
};

export const CoachingSection: React.FC<{ summary: EmployeeSummary }> = ({ summary }) => {
	const recommendations = summary.coaching_recommendations;

	if (recommendations === null || recommendations.length === 0) {
		return (
			<div className="mt-2" data-testid="coaching-empty">
				<EmptyState variant="illustration" option={2} label="Not enough activity for coaching yet" />
			</div>
		);
	}

	return (
		<ul className="mt-4 flex flex-col gap-2" data-testid="coaching-list">
			{recommendations.map((recommendation, index) => (
				<li
					key={`${recommendation.section}-${index}`}
					className="flex flex-col gap-2 rounded-lg border border-solid border-neutral-2 bg-neutral-0 p-3"
					data-testid="coaching-item"
				>
					<div className="flex items-center gap-1">
						<span
							className="flex size-6 shrink-0 items-center justify-center rounded-full border border-solid border-neutral-0 bg-primary-1"
							data-testid="coaching-item-number"
						>
							<Text size="caption" weight="semi-bold" color="neutral-9">
								{index + 1}
							</Text>
						</span>
						<Text size="paragraph-3" weight="semi-bold" color="neutral-9">
							{SECTION_LABELS[recommendation.section]}
						</Text>
					</div>
					<Text size="paragraph-3" color="neutral-9">
						{recommendation.suggestion}
					</Text>
				</li>
			))}
		</ul>
	);
};
